function readAsDataUrl(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(new Error("Não foi possível ler a imagem."));
    reader.readAsDataURL(blob);
  });
}

function canvasThumbnail(image) {
  const side = Math.min(image.width, image.height);
  const sourceX = (image.width - side) / 2;
  const sourceY = (image.height - side) / 2;
  const canvas = document.createElement("canvas");
  canvas.width = 150;
  canvas.height = 150;
  const context = canvas.getContext("2d");
  context.drawImage(image, sourceX, sourceY, side, side, 0, 0, 150, 150);
  return canvas;
}

export async function createAvatarThumbnail(file) {
  if (!file.type.startsWith("image/")) {
    throw new Error("Escolha um arquivo de imagem.");
  }
  const sourceUrl = URL.createObjectURL(file);
  const image = new Image();
  image.src = sourceUrl;
  await image.decode();
  const canvas = canvasThumbnail(image);
  URL.revokeObjectURL(sourceUrl);
  const blob = await new Promise((resolve) => canvas.toBlob(resolve, "image/webp", 0.78));
  if (!blob) {
    throw new Error("Não foi possível criar a miniatura.");
  }
  return readAsDataUrl(blob);
}